import React from 'react';
import { Users, Eye } from 'lucide-react';

export default function LiveRoomCard({ room, onClick }) {
  return (
    <div data-testid={`room-card-${room.id}`} onClick={onClick}
      className="glass-card rounded-3xl overflow-hidden cursor-pointer group hover:border-[#FF007F]/30 transition-all">
      {/* Thumbnail */}
      <div className="relative aspect-video bg-gradient-to-br from-[#FF007F]/10 to-[#4B0082]/20 overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#FF007F]/30 to-[#E0115F]/30 flex items-center justify-center">
            <img src={room.host_avatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${room.host_name}`}
              alt={room.host_name} className="w-14 h-14 rounded-full object-cover" />
          </div>
        </div>
        {/* Live badge */}
        <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-red-500/90 text-white text-xs font-semibold">
          <span className="w-1.5 h-1.5 bg-white rounded-full live-dot" />
          LIVE
        </div>
        {/* Viewer count */}
        <div className="absolute top-3 right-3 flex items-center gap-1 px-2.5 py-1 rounded-full glass text-xs">
          <Eye className="w-3 h-3" /> {room.viewer_count || 0}
        </div>
      </div>

      {/* Info */}
      <div className="p-4">
        <h3 className="font-semibold text-sm truncate mb-1 group-hover:text-[#FF007F] transition-colors">
          {room.title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-slate-400 mb-3">
          <img src={room.host_avatar || `https://api.dicebear.com/7.x/avataaars/svg?seed=${room.host_name}`}
            alt={room.host_name} className="w-5 h-5 rounded-full" />
          <span>{room.host_name}</span>
          <span className="flex items-center gap-1 ml-auto">
            <Users className="w-3 h-3" /> {room.participant_count || 0}
          </span>
        </div>
        {room.tags?.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {room.tags.slice(0, 3).map(tag => (
              <span key={tag} className="px-2 py-0.5 rounded-full bg-[#FF007F]/10 text-[#FF007F] text-[10px] font-medium">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
